module.exports = __webpack_public_path__ + "img/applestore.2928664f.svg";